(() => {
  const NAV_SELECTOR = '#MainContent [id$="__section_cXjRcx"]';
  const HERO_SELECTOR = '#MainContent [id$="__hero_zkAezp"]';
  const ROTATION_MS = 4000;

  const slides = [
    {
      label: 'SHOP ALL',
      href: '/collections/shop-all'
    },
    {
      label: 'MEME TEES',
      href: '/collections/banned-collection',
      image: 'https://cdn.shopify.com/s/files/1/0969/6588/6276/files/banned-prints-meme-slide.jpg?v=1787265861',
      alt: 'Banned Prints meme tees'
    },
    {
      label: 'COUPLE TEES',
      href: '/collections/couple-collection',
      image: 'https://cdn.shopify.com/s/files/1/0969/6588/6276/files/banned-prints-couple-slide.jpg?v=1787265877',
      alt: 'Banned Prints couple tees'
    }
  ];

  function buildImageLayer(slide, index) {
    const layer = document.createElement('div');
    layer.className = 'bp-hero-slide bp-hero-slide--image';
    layer.dataset.bpSlide = String(index);
    layer.setAttribute('aria-hidden', 'true');

    const image = document.createElement('img');
    image.className = 'bp-hero-slide__image';
    image.src = slide.image + '&width=2000';
    image.srcset = [
      slide.image + '&width=600 600w',
      slide.image + '&width=900 900w',
      slide.image + '&width=1200 1200w',
      slide.image + '&width=1600 1600w',
      slide.image + '&width=2000 2000w'
    ].join(', ');
    image.sizes = '100vw';
    image.alt = slide.alt;
    image.decoding = 'async';
    image.loading = 'eager';

    layer.appendChild(image);
    return layer;
  }

  function initHeroTabs() {
    const navigation = document.querySelector(NAV_SELECTOR);
    const hero = document.querySelector(HERO_SELECTOR);

    if (!navigation || !hero || hero.dataset.bpHeroTabsReady === 'true') return;

    const tabCandidates = Array.from(navigation.querySelectorAll('a'));
    const tabs = slides.map((slide) =>
      tabCandidates.find((tab) => tab.textContent.trim().toUpperCase() === slide.label)
    );

    const mediaWrapper = hero.querySelector('.hero__media-wrapper');
    const cta = hero.querySelector('.hero__content-wrapper > a[href]');

    if (tabs.some((tab) => !tab) || !mediaWrapper || !cta) return;

    const originalMedia = Array.from(mediaWrapper.children).filter((element) => {
      const isOverlay = Array.from(element.classList).some((className) =>
        className.startsWith('overlay')
      );
      return !isOverlay && !element.classList.contains('bp-hero-slide');
    });

    if (!originalMedia.length) return;

    const shopLayer = document.createElement('div');
    shopLayer.className = 'bp-hero-slide bp-hero-slide--shop is-active';
    shopLayer.dataset.bpSlide = '0';
    shopLayer.setAttribute('aria-hidden', 'false');
    mediaWrapper.insertBefore(shopLayer, originalMedia[0]);
    originalMedia.forEach((element) => shopLayer.appendChild(element));

    const slideLayers = [
      shopLayer,
      buildImageLayer(slides[1], 1),
      buildImageLayer(slides[2], 2)
    ];

    mediaWrapper.appendChild(slideLayers[1]);
    mediaWrapper.appendChild(slideLayers[2]);

    let activeIndex = 0;
    let timer;

    function startTimer() {
      window.clearInterval(timer);
      timer = window.setInterval(() => {
        setActive((activeIndex + 1) % slides.length);
      }, ROTATION_MS);
    }

    function setActive(index) {
      activeIndex = index;

      slideLayers.forEach((layer, layerIndex) => {
        const isActive = layerIndex === index;
        layer.classList.toggle('is-active', isActive);
        layer.setAttribute('aria-hidden', String(!isActive));
      });

      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);

        if (isActive) {
          tab.setAttribute('aria-current', 'true');
        } else {
          tab.removeAttribute('aria-current');
        }
      });

      cta.setAttribute('href', '/collections/shop-all');
    }

    tabs.forEach((tab, index) => {
      tab.classList.add('bp-hero-tab');
      tab.dataset.bpCollection = slides[index].label.toLowerCase().replace(/\s+/g, '-');
      tab.setAttribute('href', slides[index].href);
      tab.removeAttribute('role');
      tab.removeAttribute('aria-selected');
      tab.removeAttribute('aria-controls');
      tab.removeAttribute('tabindex');
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        window.clearInterval(timer);
      } else {
        startTimer();
      }
    });

    hero.dataset.bpHeroTabsReady = 'true';
    setActive(0);
    startTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroTabs, { once: true });
  } else {
    initHeroTabs();
  }
})();